import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { BASE_URL } from "../../config/api";
export default function Register({ isOpen = true, onClose = () => {} }) {
  const [step, setStep] = useState(1); // 1=form, 2=otp, 3=success

  const [formData, setFormData] = useState({
    name: "",
    mobileno: "",
    password: "",
    address: "",
    city: "",
    emailid: "",
    countrycode: "91",
  });

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // ---------------- PHONE VALIDATION ----------------
  const validatePhone = () => {
    const phone = formData.mobileno;

    if (formData.countrycode === "91") {
      return /^[6-9]\d{9}$/.test(phone);
    }
    return phone.length >= 6;
  };

  // ---------------- STEP 1: SEND OTP ----------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!validatePhone()) newErrors.mobileno = "Enter valid mobile number";
    if (!formData.password.trim()) newErrors.password = "Password is required";
    else if (formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";

    if (
      formData.emailid &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailid)
    ) {
      newErrors.emailid = "Enter valid email";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    try {
      setLoading(true);

      const fd = new FormData();
      fd.append("mobileno", formData.mobileno);
      fd.append("countrycode", formData.countrycode);

      const response = await fetch(`${BASE_URL}/send_otp.php`, {
        method: "POST",
        body: fd,
      });

      const result = await response.json();

      if (result.success) {
        setMessage("OTP sent successfully");
        setStep(2); // move to OTP screen
      } else {
        setMessage("");
        setErrors({ api: result.message || "Failed to send OTP" });
      }
    } catch (error) {
      setErrors({ api: "Server Error" });
    } finally {
      setLoading(false);
    }
  };

  // ---------------- STEP 2: VERIFY OTP + REGISTER ----------------
  const verifyOtp = async () => {
    if (!otp) {
      setErrors({ otp: "Enter OTP" });
      return;
    }

    try {
      setLoading(true);

      // VERIFY OTP
      const fd = new FormData();
      fd.append("otp", otp);
      fd.append("mobileno", formData.mobileno);

      const res = await fetch(`${BASE_URL}/verify_otp.php`, {
        method: "POST",
        body: fd,
      });

      const data = await res.json();

      if (!data.success) {
        setErrors({ otp: data.message || "Invalid OTP" });
        return;
      }

      setMessage("OTP verified ✔");

      // REGISTER USER (your old API)
      const reg = new FormData();
      reg.append("name", formData.name);
      reg.append("mobileno", formData.mobileno);
      reg.append("password", formData.password);
      reg.append("address", formData.address);
      reg.append("city", formData.city);
      reg.append("emailid", formData.emailid);
      reg.append("countrycode", formData.countrycode);

      const regRes = await fetch(`${BASE_URL}/register.php`, {
        method: "POST",
        body: reg,
      });

      const regData = await regRes.json();

      if (regData.success === false) {
        setErrors({ api: regData.message || "Registration failed" });
        return;
      }

      setStep(3);
      setMessage("Account created successfully 🎉");
    } catch (err) {
      setErrors({ api: "Server Error" });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="login-popup-overlay" onClick={onClose}>
      <div className="login-popup-card" onClick={(e) => e.stopPropagation()}>
        <button className="login-popup-close" onClick={onClose}>
          ✕
        </button>

        {/* ================= STEP 1 FORM (YOUR ORIGINAL UI) ================= */}
        {step === 1 && (
          <form onSubmit={handleSubmit}>
            <div className="login-header">
              <h2>Create Account</h2>
              <p>Register New Account</p>
            </div>

            {/* NAME */}
            <div className="login-popup-form-group">
              <label>Full Name</label>
              <input
                type="text"
                className="login-popup-input"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
              {errors.name && (
                <div className="login-popup-error">{errors.name}</div>
              )}
            </div>

            {/* MOBILE */}
            <div className="login-popup-form-group">
              <label>Mobile Number</label>

              <PhoneInput
                country={"in"}
                enableSearch={true}
                value={`${formData.countrycode}${formData.mobileno}`}
                onChange={(phone, country) => {
                  const dialCode = country.dialCode;
                  const mobile = phone.startsWith(dialCode)
                    ? phone.slice(dialCode.length)
                    : phone;

                  setFormData({
                    ...formData,
                    mobileno: mobile,
                    countrycode: dialCode,
                  });
                }}
                inputStyle={{
                  width: "100%",
                  height: "45px",
                }}
              />

              {errors.mobileno && (
                <div className="login-popup-error">{errors.mobileno}</div>
              )}
            </div>

            {/* EMAIL */}
            <div className="login-popup-form-group">
              <label>Email</label>
              <input
                type="email"
                className="login-popup-input"
                value={formData.emailid}
                onChange={(e) =>
                  setFormData({ ...formData, emailid: e.target.value })
                }
              />
              {errors.emailid && (
                <div className="login-popup-error">{errors.emailid}</div>
              )}
            </div>

            {/* CITY */}
            <div className="login-popup-form-group">
              <label>City</label>
              <input
                className="login-popup-input"
                value={formData.city}
                onChange={(e) =>
                  setFormData({ ...formData, city: e.target.value })
                }
              />
            </div>

            {/* ADDRESS */}
            <div className="login-popup-form-group">
              <label>Address</label>
              <textarea
                className="login-popup-input"
                value={formData.address}
                onChange={(e) =>
                  setFormData({ ...formData, address: e.target.value })
                }
              />
            </div>

            {/* PASSWORD */}
            <div className="login-popup-form-group">
              <label>Password</label>

              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  className="login-popup-input"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                  style={{ paddingRight: "45px" }}
                />

                <i
                  className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "18px",
                  }}
                />
              </div>

              {errors.password && (
                <div className="login-popup-error">{errors.password}</div>
              )}
            </div>

            {errors.api && (
              <div className="login-popup-error">{errors.api}</div>
            )}

            {message && (
              <div style={{ color: "green", marginTop: 10 }}>{message}</div>
            )}

            <button className="login-popup-btn" disabled={loading}>
              {loading ? "Sending OTP..." : "Create Account"}
            </button>
          </form>
        )}

        {/* ================= STEP 2 OTP ================= */}
        {step === 2 && (
          <div>
            <h2>Verify OTP</h2>

            <input
              className="login-popup-input"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            {errors.otp && (
              <div className="login-popup-error">{errors.otp}</div>
            )}

            {message && (
              <div style={{ color: "green", marginTop: 10 }}>{message}</div>
            )}

            <button className="login-popup-btn" onClick={verifyOtp}>
              {loading ? "Processing..." : "Verify OTP"}
            </button>
          </div>
        )}

        {/* ================= STEP 3 SUCCESS ================= */}
        {step === 3 && (
          <div style={{ textAlign: "center" }}>
            <h2>Account Created Successfully 🎉</h2>
            <button className="login-popup-btn" onClick={onClose}>
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
